export default __webpack_public_path__ + "static/media/Ballroll_00110.963c94a7.png";